<template>
  <div style="min-height: 100vh">
    <img
      class="hidden-sm-and-down"
      style="width: 100%"
      src="../../../assets/mock/us/组 7475.5e578cda.png"
      alt=""
    />
    <img
      class="hidden-md-and-up"
      style="width: 100%"
      src="../../../assets/mock/us/组 12924.png"
      alt=""
    />
    <div class="content cooper-heart warp">
      <div class="top">
        <h3>招贤纳士</h3>
        <span></span>
        <p>RECRUIT</p>
      </div>
      <div class="contentCenter">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title"
              ><h2 style="color: #EBCC26">
                嵌入式高级软件工程师（软件组长、软件主管方向）
              </h2>
              &nbsp;&nbsp;
              <p class="hidden-sm-and-down">全职 1名</p>
              &nbsp;&nbsp;<span class="hidden-sm-and-down"
                >发布时间：2022-08-22</span
              >
            </template>
            <div>
              <p><strong>岗位职责：</strong></p>
              <p>
                1.负责嵌入软件开发，软件移植，单元测试、参与软硬件联调、集成测试等工作；
              </p>
              <p>
                2.负责嵌入式产品的需求分析，软件的架构设计、功能实现、产品维护及性能优化；
              </p>
              <p>
                3.根据需求进行嵌入式(含驱动)设计，并负责相关设计文档的编写和维护；
              </p>
              <p>
                4.独立完成通信产品软件模块设计、代码编写、单元测试、问题跟踪；
              </p>
              <p>
                5.参与开发电子产品；完成软件、硬件联合调试，保证产品功能的实现，确保软件可靠运行；
              </p>
              <p>
                6.熟悉QTCreator界面布局,了解QTC++信号槽机制，熟悉C++多线程编程和串口应用。
              </p>
              <p>7.协助完成产品的测试和验证，编写相关文档。</p>
            </div>
            <div>
              <p><strong>岗位要求：</strong></p>
              <p>1.计算机、自动化专业等相关学科，本科学历以上；</p>
              <p>
                2.有单片机开发经验，熟练使用Keil等相关软件,并有熟练的开发调试能力；
              </p>
              <p>3.熟练掌握C程序设计，具备3年以上编程经验；</p>
              <p>4.熟练使用freertos等微操作系统和编译环境；</p>
              <p>5.精通(STM32等)任何一种MCU的开发环境及程序设计；</p>
              <p>6.有BT蓝牙开发经验，有蓝牙相关移植经验尤佳；</p>
              <p>
                7.有网关端开发经验(蓝牙,Zigbee,433等),对接云端，有设备端开发经验，对接网关设备，有相关经验加分项。
              </p>
              <p>
                8.具有严谨的逻辑思维能力，有积极向上的自我要求和坚持不懈的学习能力，有良好的沟通协调能力，团队协助分享精神，能够承担工作压力。
              </p>
            </div>
            <div>
              <p><strong>加分项：</strong></p>
              <p>1.有包含指纹电子产品软件开发经验，嵌入式软件算法移植经验。</p>
              <p>
                2.熟悉以下算法领域之一：图像处理、机器学习、深度学习、大数据分析、影像组学等，有图像相关项目经验者优先；
              </p>
              <p>
                3.熟悉机器学习（尤其是深度学习）的算法和模型开发，包括但不限于：神经网络模型设计，优化方法设计；
              </p>
              <p>
                4.掌握c/c++或Matlab语言，有使用OpenCV做过实际项目；熟悉SQLite,MYSQL的应用和基本配置与管理；
              </p>
              <p>
                5.嵌入式平台移植指纹识别算法理论研究，丰富指纹算法的应用，移植及其在嵌入式系统的实现，包括不同平台的移植。
              </p>
              <p>
                6.有参入或有经验对指纹算法性能评估、测试、验证、跟踪算法和优化应用情况；
              </p>
              <p><strong>薪酬：</strong> 面议</p>
              <p>
                <strong>工作地点：</strong>
                上海市静安区江宁路268号嘉禾中心
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="2">
            <template slot="title"
              ><h2 style="color: #EBCC26">嵌入式软件工程师</h2>
              &nbsp;&nbsp;
              <p class="hidden-sm-and-down">全职 1名</p>
              &nbsp;&nbsp;<span class="hidden-sm-and-down"
                >发布时间：2022-08-22</span
              >
            </template>
            <div>
              <p><strong>岗位职责：</strong></p>
              <p>
                1.负责嵌入软件开发，软件移植，单元测试、参与软硬件联调、集成测试等工作；
              </p>
              <p>2.负责嵌入式产品的需求分析，功能实现、产品维护及性能优化；</p>
              <p>
                3.根据需求进行嵌入式(含驱动)设计，并负责相关设计文档的编写和维护；
              </p>
              <p>
                4.独立完成通信产品软件模块设计、代码编写、单元测试、问题跟踪；
              </p>
              <p>
                5.参与开发电子产品；完成软件、硬件联合调试，保证产品功能的实现，确保软件可靠运行；
              </p>
              <p>6.协助完成产品的测试和验证，编写相关文档。</p>
            </div>
            <div>
              <p><strong>岗位要求：</strong></p>
              <p>1.计算机、自动化专业等相关学科，专科学历以上；</p>
              <p>
                2.有单片机开发经验，熟练使用Keil等相关软件,并有熟练的开发调试能力；
              </p>
              <p>3.熟练掌握C程序设计，具备1年以上编程经验；</p>
              <p>4.熟练使用freertos等微操作系统和编译环境；</p>
              <p>5.精通(STM32等)任何一种MCU的开发环境及程序设计；</p>
              <p>
                6.有Wi-Fi，BT蓝牙，Zigbee，433，UWB，Z-ware等任何一种短距离无线开发经验尤佳。有BT蓝牙开发经验，有蓝牙相关移植经验尤佳；
              </p>
              <p>
                7.有网关端开发经验(蓝牙,Zigbee,433等),对接云端，有设备端开发经验，对接网关设备，有相关经验为加分项。
              </p>
              <p>
                8.熟悉QTCreator界面布局,了解QTC++信号机制，熟悉C++多线程编程和串口应用；有相关经验为加分项。
              </p>
              <p>
                9.具有严谨的逻辑思维能力，有积极向上的自我要求和坚持不懈的学习能力，有良好的沟通协调能力，团队协助分享精神，能够承担工作压力。
              </p>
              <p><strong>薪酬：</strong> 面议</p>
              <p>
                <strong>工作地点：</strong>
                上海市静安区江宁路268号嘉禾中心
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="3">
            <template slot="title"
              ><h2 style="color: #EBCC26">架构师/高级后台开发工程师</h2>
              &nbsp;&nbsp;
              <p class="hidden-sm-and-down">全职 1名</p>
              &nbsp;&nbsp;<span class="hidden-sm-and-down"
                >发布时间：2021-09-23</span
              >
            </template>
            <div>
              <p><strong>岗位职责：</strong></p>
              <p>
                1.根据软件开发需要，主导完成软件产品需求分析，架构设计，业务逻辑设计和开发。
              </p>
              <p>
                3.根据项目开发方案，进行产品架构、数据结构设计等，保证程序开发的规范；
              </p>
              <p>4.负责核心系统的架构设计与实现。</p>
              <p>5.负责项目中关键技术难点的攻关和预研。</p>
              <p>6.负责搭建公司各系统的业务解决方案的评估及开发架构的制定。</p>
              <p>7.参与部门设计评审与Code Review。</p>
              <p>
                8.负责服务端需求的开发、维护、测试，高质量完成需求交付；对代码持续进行重构与优化，提升性能可靠性和可维护性；
              </p>
            </div>
            <div>
              <p><strong>岗位要求：</strong></p>
              <p>1.计算机相关专业，具有本科以上学历；有交付式网站实施经验；</p>
              <p>
                2.三年以上微服务设计经验，五年以上Java开发经验，有扎实的Java语言基础；
              </p>
              <p>
                3.精通springcloud/springboot/dubbo/RPC等微服务架构原理，特别是spring
                cloud要有多个项目的实际搭建经验；
              </p>
              <p>
                4.熟悉数据库的应用，精通主流数据库Mysql、Oracle，有SQL调优经验优先。熟练掌握SQL，有关系型/NoSQL数据库的实际使用经验，熟悉各类数据存储中间件的使用；熟悉数据库存储及索引原理；
              </p>
              <p>
                5.对于Java基础技术体系（包括JVM、类装载机制、多线程并发、IO、网络、RPC）有一定的掌握和应用经验，
                熟练掌握Jconsole、Jmap、Jstack等Java调试工具；
              </p>
              <p>
                6.熟练使用docker、k8s等devops周边工具，有容器管控、自动运维、服务监控等领域实践经验优先；
              </p>
              <p>
                7.精通JAVA或c/c++基础扎实，熟悉JVM、精通IO、多线程、集合等基础框架，熟悉常用的设计模式和开源框架；
              </p>
              <p>
                8.熟悉分布式服务框架，有实战经验，精通大流量、高并发、高性能的分布式系统的设计及应用，擅长性能调优者优先。
              </p>
              <p>
                9.熟悉主流后台技术架构，大数据分析，了解大数据处理框架的开发；
              </p>
              <p>10.良好的沟通技能，团队合作能力，勤奋好学，热爱技术。</p>
              <p><strong>薪酬：</strong> 面议</p>
              <p>
                <strong>工作地点：</strong>
                上海市静安区江宁路268号嘉禾中心
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="activeNames">
          <el-collapse-item name="4">
            <template slot="title"
              ><h2 style="color: #EBCC26">研发经理</h2>
              &nbsp;&nbsp;
              <p class="hidden-sm-and-down">全职 1名</p>
              &nbsp;&nbsp;<span class="hidden-sm-and-down"
                >发布时间：2022-06-01</span
              >
            </template>
            <div>
              <p><strong>岗位职责：</strong></p>
              <p>
                1.根据软件开发需要，主导完成软件产品需求分析，架构设计，业务逻辑设计和开发
              </p>
              <p>2.制定新产品研发计划，论证计划可行性；</p>
              <p>3.负责搭建公司各系统的业务解决方案的评估及开发架构的制定。</p>
              <p>
                4.根据公司的研发流程，负责业务系统的核心模块的设计和开发工作。
              </p>
              <p>5.根据研发要求，编制相关开发制度与规范。</p>
              <p>
                6.负责组织开发并且指导团队完成产品设计、产品研发以满足市场的需求；
              </p>
              <p>
                7.制定良好的技术研发体系,核心研发人员沟通与管理,持续提升公司整体的技术能力；
              </p>
              <p>
                8.研究新产品开发、根据不同领域的客户要求，提出有效的解决方案。
              </p>
            </div>
            <div>
              <p><strong>岗位要求：</strong></p>
              <p>
                1.计算机相关专业，具有本科以上学历；有交付式网站实施经验或APP上市优佳；
              </p>
              <p>
                2.八年以上科技项目研发经验；有企业科研开发项目且独立领导经验者优先。
              </p>
              <p>
                3.了解指纹传感器、移动通信网架构等基本知识与原理，熟悉WiFi、LoRa、NBloT、MQTT、CoAP等关键通信组网技术；精通MySQL和JVM；并具有相关技术的综合组网经验，对新兴技术敏感，能够预测未来的技术发展趋势，提前做技术储备；
              </p>
              <p>
                4.精通手机App的开发流程，指导开发人员完成服务器端、App端（Android、IOS）、设备端的开发、调试、测试、和验收，熟悉git或SVN等版本控制工具，具有软件架构经验；
              </p>
              <p>
                5.熟悉FreeRtos操作系统；乐鑫ESP32、TCPSocket编程；数据库技术和SQLServer；熟悉服务器集群、负载均衡方案，分布式数据库；
              </p>
              <p>
                6.熟悉主流后台技术架构，大数据分析，了解大数据处理框架的开发；
              </p>
              <p>
                7.熟悉物联网安全规范，了解主流的物联网相关软件及硬件加密技术，包括设备级的双向认证，基于策略的授权管理等，熟悉ASE、CLEFIA等主流加密算法；
              </p>
              <p>8.有成功APP产品开发上市经验，正常上线运营经验为佳；</p>
              <p>
                9.熟悉低功耗技术，熟悉低功耗应用中服务端与设备端的通信方式，优化设备端功耗；
              </p>
              <p>
                10.富有爱心，热衷科技教育及科技创造，勇于接受挑战，对于创新创造有很大热情良好的执行力和抗压能力；有良好的团队精神，沟通协调能力。
              </p>
              <p><strong>薪酬：</strong> 面议</p>
              <p>
                <strong>工作地点：</strong>
                上海市静安区江宁路268号嘉禾中心
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
    };
  },
};
</script>

<style lang="scss" scoped>
.top {
  text-align: center;
  margin: 0.825rem auto;
  h3 {
    margin-top: 1.25rem;
  }
  span {
    width: 1.25rem;
    height: 3px;
    display: inline-block;
    background-color: #EBCC26;
  }
}
.container {
  // banner图
  .banner {
    img {
      width: 100%;
    }
  }
  h2 {
    text-align: center;
  }
  .cc {
    margin: 0 auto;
    margin-top: 10px;
    display: block;
    border-width: 0px;
    width: 21px;
    height: 2px;
    background-color: #EBCC26;
    border: none;
    border-radius: 2px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .ff {
    text-align: center;
    color: #333333;
    font-size: 12px;
  }
  // 内容
  .content {
    background-color: rgb(255, 255, 255);
    text-align: left;
    padding-top: 40px;
    .span {
      color: gray;
    }
    .contentCenter {
      p {
        font-size: 14px;
      }
    }
    .companyCulture {
      width: 1200px;
      height: 600px;
      .companyCultureLeft {
        float: left;
        width: 368px;
        height: 600px;
        img {
          display: block;
          width: 368px;
          height: 207px;
        }
        .imgTwo {
          margin-top: 80px;
        }
      }
      .companyCultureCenter {
        float: left;
        margin-left: 47px;
        width: 367px;
        height: 600px;
        img {
          display: block;
          width: 367px;
          height: 496px;
        }
      }
      .companyCultureRight {
        float: left;
        margin-left: 47px;
        width: 369px;
        height: 600px;
        img {
          display: block;
          width: 100%;
          height: 250px;
        }
        .imgTwo {
          height: 201px;
          margin-top: 40px;
        }
      }
    }
  }

  h5 {
    margin-top: 10px;
    text-align: left;
    color: #333333;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  .companyText {
    text-align: left;
    color: #777777;
    font-size: 12px;
  }
  .company,
  .companyNum {
    font-size: 12px;
    color: #666666;
    display: block;
    text-align: left !important;
  }
  .companyNum {
    font-size: 16px;
    margin-left: 5px;
    display: inline-block;
    text-align: left;
    color: #EBCC26;
  }
}
::v-deep .el-collapse-item__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
